import React, { Component } from 'react'
import starNotColor from './../../img/star-not-color.svg';
import starColor from '../../img/star-color.svg';
import './stars.scss';
import PropTypes from "prop-types";

class Stars extends Component {

  render() {
    const { rating, isWithNumber} =  this.props;
    const countNotColorStars = 5 - rating;
    let ratingStars = [];

    for (let i = 0; i < rating; i++) {
      ratingStars.push(<i key={i} className="stars__img stars__img--colored">★</i>);
    }

    if (countNotColorStars !== 0) {
      for (let i = rating; i < 5; i++) {
        ratingStars.push(<i key={i} className="stars__img stars__img--not-colored">★</i>);
      }
    }

    return (
      <div className="stars" >
      { ratingStars }
       {isWithNumber ? <span className="stars__caption">{parseInt(rating).toFixed(1)}</span>: null}
      </div>
    )
  }
}

Stars.propTypes = {
  rating: PropTypes.string,
  isWithNumber: PropTypes.bool
};

export default Stars;



// WEBPACK FOOTER //
// ./src/components/stars/stars.js